import Phaser from 'phaser';

export class WaveDisplay {
  private text: Phaser.GameObjects.Text;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    this.text = scene.add.text(x, y, 'Wave 0', {
      fontSize: '20px',
      fontFamily: 'Arial Black, Arial, sans-serif',
      color: '#ffffff',
    });
  }

  private lastText: string = '';

  update(wave: number, isActive: boolean, isShopPhase: boolean): void {
    let newText = '';
    if (wave === 0) {
      newText = 'Wave 1';
    } else if (isActive) {
      newText = `Wave ${wave}`;
    } else if (isShopPhase) {
      newText = `Wave ${wave}`;
    } else {
      newText = `Wave ${wave} - Complete`;
    }

    if (this.lastText !== newText) {
      this.text.setText(newText);
      this.lastText = newText;
    }
  }
}
